import React from "react";
import One from "../data/tripassets/one.jpg";
import Two from "../data/tripassets/two.jpg";
import Three from "../data/tripassets/three.jpg";
import Five from "../data/tripassets/five.jpg";
import Six from "../data/tripassets/six.jpg";
import Seven from "../data/tripassets/seven.jpg";
import Eight from "../data/tripassets/eight.jpg";
import Nine from "../data/tripassets/nine.jpg";
import Ten from "../data/tripassets/10.jpg";
import Twelve from "../data/tripassets/12.jpg";
import Thirteen from "../data/tripassets/13.jpg";
import Fouteen from "../data/tripassets/14.jpg";
import Fifteen from "../data/tripassets/15.jpg";
import Sixteen from "../data/tripassets/16.jpg";
import Seventenn from "../data/tripassets/17.jpg";
import Eightteen from "../data/tripassets/18.jpg";
import Nineteen from "../data/tripassets/19.jpg";
import Twenty from "../data/tripassets/20.jpg";
import TwentyOne from "../data/tripassets/21.jpg";
import Twentytwo from "../data/tripassets/22.jpg";
import Twentythree from "../data/tripassets/23.jpg";
import Twentyfour from "../data/tripassets/24.jpg";
import Twentyfive from "../data/tripassets/25.jpg";

//<img src={Pic} alt="four" className="img-fluid" width="20%" />

function Trip() {
  return (
    <div className="text-light ">
      <br />
      <h1 className="text-center">Pics of Trips</h1>
      <br />
      <br />
      <div className="rown">
        <div className="column">
          <img src={Nineteen} alt="one" className="img-fluid" width="20%" />
          <img src={One} alt="one" className="img-fluid" width="20%" />
          <img src={Nine} alt="four" className="img-fluid" width="20%" />
          <img src={Twelve} alt="four" className="img-fluid" width="20%" />
          <img src={Fifteen} alt="four" className="img-fluid" width="20%" />
          <img src={TwentyOne} alt="four" className="img-fluid" width="20%" />
        </div>
        <div className="column">
          <img src={Twenty} alt="three" className="img-fluid" width="20%" />
          <img src={Three} alt="three" className="img-fluid" width="20%" />
          <img src={Thirteen} alt="four" className="img-fluid" width="20%" />
          <img src={Ten} alt="four" className="img-fluid" width="20%" />
          <img src={Sixteen} alt="four" className="img-fluid" width="20%" />
          <img src={Twentytwo} alt="four" className="img-fluid" width="20%" />
          <img src={Twentythree} alt="four" className="img-fluid" width="20%" />
        </div>
        <div className="column">
          <img src={Five} alt="four" className="img-fluid" width="20%" />
          <img src={Six} alt="four" className="img-fluid" width="20%" />
          <img src={Fouteen} alt="four" className="img-fluid" width="20%" />
          <img src={Seventenn} alt="four" className="img-fluid" width="20%" />
          <img src={Twentyfour} alt="four" className="img-fluid" width="20%" />
        </div>
        <div className="column">
          <img src={Seven} alt="four" className="img-fluid" width="20%" />
          <img src={Eight} alt="four" className="img-fluid" width="20%" />
          <img src={Two} alt="two" className="img-fluid" width="20%" />
          <img src={Eightteen} alt="four" className="img-fluid" width="20%" />
          <img src={Twentyfive} alt="four" className="img-fluid" width="20%" />
        </div>
      </div>
    </div>
  );
}

export default Trip;
